import { AsyncState, none, Option, unloadedAsyncState } from "widgets-for-react"
import { ParsedNodeEvent } from "../../../api/drupal/types"
import { EventDetailsFrontend } from "../../../backendApi/generated"
import { emptyFragment } from "../../../utils/react"
import { JumboComponent } from "../../Jumbo/Jumbo"
import { NoticeProps } from "../../Notice"
import { EventsConfig } from "../EventState"
import { EventsOverviewClassNames } from "../EventOverview/EventOverviewState"

export interface EventDetailsState {
  eventId: string
  event: AsyncState<EventDetailsFrontend>
  Jumbo: JumboComponent
  renderCustomCmsPage: EventsConfig['renderCustomCmsPage']
  Blocks: EventsConfig['Blocks']
}

export const initialEventDetailsState: EventDetailsState = {
  eventId: null,
  event: unloadedAsyncState<EventDetailsFrontend>(),
  Jumbo: emptyFragment,
  renderCustomCmsPage: () => none(),
  Blocks: emptyFragment
}

export type EventDetailsLayoutProps = Omit<EventDetailsState, 'event' | 'Blocks' > & {
  pageTitle: string
  event: EventDetailsFrontend
  notice?: NoticeProps
  eventsOverviewClassNames: EventsOverviewClassNames
}

export type EventBlocks = ParsedNodeEvent['field_paragraphs']

export interface EventDetailsCmsProps {
  readonly pageTitle: string
  readonly headerTitle: string
  readonly subtitle: string
  readonly description: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly imageAlt: string
  readonly noticeTitle: string
  readonly noticeContents: string
  readonly blocks: EventBlocks
}